// extracted by mini-css-extract-plugin
export default {"root":"AdminDefault-modules__root__wUEhH","show-keyframe":"AdminDefault-modules__show-keyframe__obRL9"};